export default __webpack_public_path__ + "static/media/winner.e3f637ca.mp3";